module.exports = __webpack_public_path__ + "static/media/LP-header-right.5c3eb085.png";